<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2.99805 21.0001L10.5464 13.4517M10.5464 13.4517L2.99805 3.00012H7.99805L13.4496 10.5485M10.5464 13.4517L15.998 21.0001H20.998L13.4496 10.5485M20.998 3.00012L13.4496 10.5485"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>